export default __webpack_public_path__ + "static/media/pic1.ece76297.jpg";